/**
 * Wiederverwendbare Pflichtfeld-Prüfung mit „Hinspringen" (Jul-2026, User-Wunsch).
 *
 * Nutzung:
 *   const missing = collectMissing([
 *     { ok: !!name.trim(), label: "Name", testid: "field-name" },
 *     { ok: Number(x) > 0, label: "Betrag", testid: "field-x" },
 *   ]);
 *   if (missing.length) { focusFirstMissing(missing); return; }
 *
 * `focusFirstMissing` scrollt zum ersten fehlenden Feld, fokussiert es,
 * hebt es kurz rot hervor und zeigt einen Toast mit dem Feldnamen.
 */
import { toast } from "sonner";

export function collectMissing(rules) {
    return (rules || []).filter((r) => !r.ok);
}

export function focusFirstMissing(missing, { toastPrefix = "Bitte Pflichtfeld ausfüllen" } = {}) {
    const first = (missing || [])[0];
    if (!first) return false;
    const labels = missing.map((m) => m.label).filter(Boolean);
    toast.error(
        missing.length === 1
            ? `${toastPrefix}: ${first.label}`
            : `${toastPrefix}: ${first.label} (und ${missing.length - 1} weitere)`,
    );
    if (first.testid) {
        // Kurze Verzögerung, damit ein evtl. gerade geöffneter Block gerendert ist.
        setTimeout(() => {
            const el = document.querySelector(`[data-testid="${first.testid}"]`);
            if (!el) return;
            try { el.scrollIntoView({ behavior: "smooth", block: "center" }); } catch { /* noop */ }
            const focusable = el.matches("input,select,textarea,button")
                ? el
                : el.querySelector("input,select,textarea,button");
            try { focusable?.focus({ preventScroll: true }); } catch { /* noop */ }
            const target = focusable || el;
            target.classList.add("tw-field-error-flash");
            setTimeout(() => target.classList.remove("tw-field-error-flash"), 1800);
        }, 60);
    }
    return true;
}
